var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FEE6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.5 8.75H10.5C8.84315 8.75 7.5 10.0931 7.5 11.75V19.25C7.5 20.9069 8.84315 22.25 10.5 22.25H19.5C21.1569 22.25 22.5 20.9069 22.5 19.25V11.75C22.5 10.0931 21.1569 8.75 19.5 8.75Z",
    fill: "#DE8D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.032 12.188C10.2044 11.9296 10.5536 11.8597 10.8121 12.032L13.648 13.9226C14.4667 14.4685 15.5334 14.4685 16.3521 13.9226L19.188 12.032C19.4465 11.8597 19.7958 11.9296 19.9681 12.188C20.1404 12.4465 20.0706 12.7958 19.8121 12.9681L16.9762 14.8587C15.7795 15.6564 14.2206 15.6564 13.0239 14.8587L10.188 12.9681C9.92956 12.7958 9.85971 12.4465 10.032 12.188Z",
    fill: "#DE8D8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9375 17.75C6.9375 17.4393 7.18934 17.1875 7.5 17.1875H12C12.3107 17.1875 12.5625 17.4393 12.5625 17.75C12.5625 18.0607 12.3107 18.3125 12 18.3125H7.5C7.18934 18.3125 6.9375 18.0607 6.9375 17.75Z",
    fill: "#DE8D8D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9375 20C6.9375 19.6893 7.18934 19.4375 7.5 19.4375H12C12.3107 19.4375 12.5625 19.6893 12.5625 20C12.5625 20.3107 12.3107 20.5625 12 20.5625H7.5C7.18934 20.5625 6.9375 20.3107 6.9375 20Z",
    fill: "#DE8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuEmail);
export default __webpack_public_path__ + "static/media/menu_email.5eb81fb8ee347d3668511dd1ba7b6200.svg";
export { ForwardRef as ReactComponent };